// When a document comment was written, as the comment card says it (#13194).
import {
  formatInstant,
  formatInstantDateClock,
  parseInstant,
  todayInZone,
  viewerTimeZone,
} from "@/utils/temporal";

/** When a comment was written, in the viewer's zone: the clock for today,
 *  the date before that, and the year too before this year. */
export const commentTime = (at: string, now: Date = new Date()): string => {
  const zone = viewerTimeZone();
  const instant = parseInstant(at);
  if (!instant) return at;
  const day = formatInstant(at, zone);
  const today = todayInZone(zone, now);
  if (day === today) {
    return new Intl.DateTimeFormat(undefined, {
      timeZone: zone,
      hour: "numeric",
      minute: "2-digit",
    }).format(new Date(instant.epochMilliseconds));
  }
  // The year once it is not this year's, so an old thread never reads as
  // this autumn's.
  return new Intl.DateTimeFormat(undefined, {
    timeZone: zone,
    month: "short",
    day: "numeric",
    ...(day.slice(0, 4) !== today.slice(0, 4) && { year: "numeric" }),
  }).format(new Date(instant.epochMilliseconds));
};

/** When a comment was edited, in the viewer's zone: the day and the clock,
 *  and the year too once the day is not in this year. */
export const commentEditedTime = (at: string, now: Date = new Date()): string =>
  formatInstantDateClock(at, viewerTimeZone(), now);
